<template lang="">
    <div>
        <div class="classes-wrap box">
            <div class="info">
                <div class="image">
                    <van-image :src="info.classes_thumb"></van-image>
                </div>
                <div class="right">
                    <h1 v-text="info.classes_name"></h1>
                    <div class="desc">
                        <img src="@images/address-ico.png" alt="" />
                        <span>
                            教室：
                            <b class="nomarl">{{ info.classes_address }}</b>
                        </span>
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div class="course">
                <span>课程名称</span>
                <span class="value" v-text="info.name"></span>
            </div>
        </div>
        <div class="sign-box box">
            <div class="time-wrap">
                <span>签到时间：</span>
                <span class="value" v-text="info.sign_start + '-' + info.sign_end"></span>
            </div>
            <div class="btn-wrap">
                <button type="button" class="sign-btn" @click="actionSign">
                    {{ info.is_sign ? '已签到' : '签到' }}
                </button>
            </div>
            <div class="address-wrap">
                <span>当前位置：</span>
                <span class="value" v-text="sign.signed_address"></span>
            </div>
            <div class="desc">
                点击签到按钮，完成签到
            </div>
        </div>
    </div>
</template>
<script>
import { empty } from '@utils';
import { getClassesCourse } from '@api/classes';
import { wxShowLocation } from '@libs/wechat';
import { jsonp } from 'vue-jsonp';
import { actionSignCourse } from '@api/user';
export default {
    name: 'ClassesSign',
    data() {
        return {
            info: {
                classes_name: '',
                name: '',
                classes_address: '',
                classes_thumb: '',
                sign_start: '',
                sign_end: '',
                id: 0,
                is_sign: false
            },
            sign: {
                signed_address: '',
                latitude: 0,
                longitude: 0
            }
        };
    },
    created() {
        this.$set(this.info, 'id', this.$route.params.id || 0);
        if (empty(this.info.id) || this.info.id <= 0)
            return this.$dialog.error('参数错误').then(() => {
                this.$router.replace('/');
            });
        this.getCourseInfo();
    },
    watch: {
        $route(n) {
            if (n.name === 'ClassesSign') {
                this.getCourseInfo();
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getLocationInfo();
        });
    },
    methods: {
        getCourseInfo() {
            let that = this;
            getClassesCourse(this.info.id)
                .then(res => {
                    that.$set(that, 'info', res.data);
                })
                .catch(err => {
                    return that.$dialog.error(err, { duration: 5000 }).then(() => {
                        this.$router.replace('/');
                    });
                });
        },
        getLocationInfo() {
            let that = this;
            wxShowLocation('gcj02').then(res => {
                that.$set(that.sign, 'latitude', res.latitude);
                that.$set(that.sign, 'longitude', res.longitude);
                jsonp(
                    'https://apis.map.qq.com/ws/geocoder/v1/?key=XHMBZ-YQGCW-WDMRY-333XC-JLX3O-JSBDW&location=' +
                        res.latitude +
                        ',' +
                        res.longitude +
                        '&output=jsonp'
                ).then(res => {
                    console.log(res);
                    if (res.status == 0) {
                        that.$set(that.sign, 'signed_address', res.result.address);
                    }
                });
            });
        },
        actionSign() {
            if (this.info.is_sign) return;
            let that = this;
            this.$dialog.loading('签到中...');
            actionSignCourse(this.info.id, this.sign)
                .then(res => {
                    return this.$dialog.close().then(() => {
                        that.$dialog.success(res.msg, { duration: 3000 }).then(() => {
                            this.$router.replace('/');
                        });
                    });
                })
                .catch(err => {
                    return this.$dialog.close().then(() => {
                        that.$dialog.error(err);
                    });
                });
        }
    }
};
</script>
